/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InvsysLogBusinessEngagementEventArgs = {
  eventType?: number | null;
  targetId?: string | null;
  appPlatformType?: number | null;
  appVersion?: string | null;
};
export type invsysLogShopBusinessEngagementEventsMutationVariables = {
  events: Array<InvsysLogBusinessEngagementEventArgs>;
};
export type invsysLogShopBusinessEngagementEventsMutationResponse = {
  readonly invsysLogShopBusinessEngagementEvents: {
    readonly success: boolean;
  };
};
export type invsysLogShopBusinessEngagementEventsMutation = {
  readonly response: invsysLogShopBusinessEngagementEventsMutationResponse;
  readonly variables: invsysLogShopBusinessEngagementEventsMutationVariables;
};

/*
mutation invsysLogShopBusinessEngagementEventsMutation(
  $events: [InvsysLogBusinessEngagementEventArgs!]!
) {
  invsysLogShopBusinessEngagementEvents(events: $events) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'events',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'events',
            variableName: 'events',
          },
        ],
        concreteType: 'InvsysLogBusinessEngagementEventsResponse',
        kind: 'LinkedField',
        name: 'invsysLogShopBusinessEngagementEvents',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'invsysLogShopBusinessEngagementEventsMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'invsysLogShopBusinessEngagementEventsMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '7df99b473a84f1a9419a198101f83086',
      id: null,
      metadata: {},
      name: 'invsysLogShopBusinessEngagementEventsMutation',
      operationKind: 'mutation',
      text: 'mutation invsysLogShopBusinessEngagementEventsMutation(\n  $events: [InvsysLogBusinessEngagementEventArgs!]!\n) {\n  invsysLogShopBusinessEngagementEvents(events: $events) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'cc59a093be9448f2ab34eb0989fa27ed';
export default node;
